<template>
    <div>
        <!--        新增打卡导入-->
        <div></div>
        <el-form :label-position="labelPosition" :rules="rules" ref="ruleForm" label-width="80px" :model="formData">
            <el-form-item label="姓名" prop="name">

                <el-select :filter-method="namesearch" style="width: 260px;"  @change="nameChange"  filterable @input.native="delaySearch" class="inputwidth" v-model="formData.name">
                    <el-option v-for="(val,index) in searchPeople" :key="index" :label="val.name+'('+val.department+')'" :value="val.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="部门" prop="department">
                <el-input disabled style="width: 260px;" v-model="formData.department"></el-input>
            </el-form-item>
            <el-form-item label="打卡时间" prop="clockInTime">
                <el-date-picker
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 260px;"
                        v-model="formData.clockInTime"
                        type="datetime"
                        placeholder="选择日期时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item style="margin-left: 40px">
                <el-button type="primary" @click="onSubmit">{{$t('button_save')}}</el-button>
                <el-button @click="close">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import * as API from "../api"
    import {mapActions} from "vuex";

    export default {
        name: "PunchImport",
        props:{

        },
        data(){
            return{
                search:'',
                // value:'',
                searchPeople:[],

                labelPosition: 'right',//label对齐方式
                formData: {
                    name: '',
                    department: '',
                    clockInTime:'',
                },
                rules: {
                    name: [
                        {  required: true, message: '请选择姓名', trigger: 'change' }
                    ],
                    department: [
                        { required: true, message: '请输入部门', trigger: 'blur' }
                    ],
                    clockInTime: [
                        {  required: true, message: '请选择时间', trigger: 'change' }
                    ],

                }
            }
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            namesearch(val){
                this.formData.name=val
                this.searchUser()
                // console.log(this.formData.name)
            },
            //延迟搜索
            delaySearch(val){
                // if(this.timer){
                //     clearTimeout(this.timer)
                // }
                // if(val!==''&&val.data!==null){
                //     this.timer=setTimeout(()=>{
                //         if(val!==''&&val.data!==null){
                //             this.searchUser()
                //         }
                //     },500)
                // }
                // this.search=val.data
            },
            //名称搜索
            nameChange(val){
                // this.formData.userId=val
                this.search=val
                let newname=this.searchPeople.filter((item)=>{
                    return item.id==val
                })
                // console.log(val)
                this.formData.name=newname[0].name
                this.formData.userId=newname[0].id
                this.formData.department=newname[0].department

            },
            close(){
                this.$emit('close')
            },
            onSubmit(){
                // console.log(this.formData)
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        // console.log(this.formData)
                        this.$emit('savePunch',this.formData)

                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
                });
            },
//搜索查询
            async searchUser() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    keyname:this.formData.name
                }
                let res = await API.searchUser(params);
                if (res.code == 1) {
                    this.searchPeople=res.data
                    // console.log(res.data)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .lable-width{
        text-align: center;
    }
    /deep/.el-input.isdisabled .el-input__inner{
        color:black !important;
    }
</style>